window.addEventListener('load', () => {
  let mobileCloseButton = document.querySelector('#close-button');

  if (mobileCloseButton) {
    mobileCloseButton.addEventListener('click', () => {
      document.querySelector('header').classList.remove('open-menu');
      document.querySelector('.mobile-button').classList.remove('open');

      if (document.documentElement.style.overflowY === "hidden") {
        document.documentElement.style.overflowY = null;
      }
    });
  }
});
